export default __webpack_public_path__ + "static/firemaking-4db423d643045a4fd4f6e9193ffcb861.png";